import React, { forwardRef, useState } from 'react';

import IconButton from 'shell/components/IconButton';
import TextInput from 'shell/components/TextInput';

const PasswordInput = forwardRef((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextInput
            ref={ref}
            disablePointerEventsOnIcon={false}
            endIcon={
                <IconButton
                    aria-label={'toggle password visibility'}
                    kind={showPassword ? 'hide' : 'visible'}
                    variant={'square'}
                    onClick={() => setShowPassword((current) => !current)}
                    onMouseDown={(e) => e.preventDefault()}
                />
            }
            type={showPassword ? 'text' : 'password'}
            {...props}
        />
    );
});

export default PasswordInput;
